/* eslint-disable consistent-return */
/* eslint-disable react/no-array-index-key */
/* eslint-disable max-len */
/* eslint-disable react/react-in-jsx-scope */
import { useState, useEffect } from 'react';
import { showNotification } from '@mantine/notifications';
import { ReportMoney } from 'tabler-icons-react';
import {
  Checkbox, Tooltip, useMantineColorScheme,
} from '@mantine/core';
import Layout from '../../Layout/Layout';
import useSorting from '../../../components/CommonFunction/useSorting';
import { loadingStates, assetPrefix, renderNumber } from '../../../utilities/general';
import { apiWrapWithErrorWithData } from '../../../utilities/apis/apiHelpers';
import styles from './Wallet.module.css';
import WalletTabLoading from '../../../components/LoadingPlaceholder/WalletTabLoading';
import { companyWalletOverviewApi } from '../../../utilities/apis/companyData';
import {
  tradersListApi, traderWalletApi,
} from '../../../utilities/apis/traders';
import FilterExpansionComponent from './FilterExpansionComponent';
import WalletLoading from '../../../components/LoadingPlaceholder/WalletLoading';
import AreaChartNew from './AreaChartNew';

const Wallet = () => {
  const [walletData, setWalletData] = useState(null);
  const [walletOverView, setWalletOverView] = useState(null);
  const [filteredWalletData, setFilteredWalletData] = useState(null);
  const [isFilterActive, setIsFilterActive] = useState(false);
  const [dataLoading, setDataLoading] = useState(loadingStates.NO_ACTIVE_REQUEST);
  const [checkboxes, setCheckboxes] = useState({
    filter: false,
    removeDust: true,
  });

  const { colorScheme } = useMantineColorScheme();

  const handleChange = (event) => {
    const { name, checked } = event.currentTarget;
    setCheckboxes((prevState) => ({
      ...prevState,
      [name]: checked,
    }));
  };

  const fetchTraderWalletOverview = async () => {
    setDataLoading(loadingStates.LOADING);
    const resp = await apiWrapWithErrorWithData(companyWalletOverviewApi());

    if (resp?.success) {
      setWalletOverView(resp?.data);
    } else {
      showNotification({
        color: 'red',
        message: 'Could not load wallet overview',
        title: 'Error while fetching wallet overview',
      });
    }
  };

  const getWalletData = async (userId) => {
    setDataLoading(loadingStates.LOADING);
    const walletResp = await apiWrapWithErrorWithData(traderWalletApi(userId));
    setDataLoading(loadingStates.FINISHED);
    if (walletResp?.success && walletResp?.data) {
      setWalletData(walletResp?.data);
      setFilteredWalletData(walletResp?.data);
      setDataLoading(loadingStates.FINISHED);
    } else {
      showNotification({
        color: 'red',
        message: 'Could not load  wallet',
        title: 'Error while fetching wallet',
      });
    }
  };

  const getTradersListingData = async () => {
    setDataLoading(loadingStates.LOADING);
    const traderListResp = await apiWrapWithErrorWithData(tradersListApi());
    if (traderListResp?.success) {
      const accountId = traderListResp.data?.[0].accountId;
      fetchTraderWalletOverview();
      getWalletData(accountId);
    } else {
      showNotification({
        color: 'red',
        title: 'Error',
        message: 'Failed to load traders list.',
      });
    }
  };

  useEffect(() => {
    getTradersListingData();
  }, []);

  useEffect(() => {
    if (!checkboxes.filter && isFilterActive) {
      getTradersListingData();
    }
  }, [checkboxes.filter, isFilterActive]);

  const { items, requestSort, sortConfig } = useSorting(filteredWalletData, 'totalValueUsd');

  const getClassName = (value, item) => {
    const itemValue = Number.parseFloat(Number(value).toFixed(2));
    const totalValue = item != null ? Number.parseFloat(Number(item).toFixed(2)) : 0;
    switch (true) {
      case itemValue === totalValue:
        return 'text-base';
      case itemValue < totalValue:
        return 'text-red-500';
      case itemValue > totalValue:
        return 'text-green-500';
      default:
        return '';
    }
  };

  const getClassNamesFor = (name) => {
    if (!sortConfig) {
      return;
    }
    return sortConfig.key === name ? sortConfig.direction : undefined;
  };

  const walletOverViewData = walletOverView?.oneMonthData.map((item) => ({
    ...item,
    value: item.totalValueUsd,
  }));

  return (
    <div
      className="w-full flex h-full"
    >
      <Layout>
        <div className="flex flex-col w-[90%] mx-auto mt-4 px-4 gap-[18px]">
          <div className="flex flex-col gap-4 bg-white dark:bg-[#26282C] text-base rounded-md">
            {
              dataLoading === loadingStates.LOADING
              && <WalletLoading />
            }
            {dataLoading === loadingStates.FINISHED && (
              <div className="flex h-36 px-7 py-3 items-center justify-between w-full">
                <div className="text-[#3A3A3A] font-semibold text-[26px] dark:text-[#F2F2F2] p-2 w-[25%]">
                  Wallet
                </div>
                <div className="w-[53%] h-40">
                  {/* <InvestmentLineCharts
                    loading="FINISHED"
                    // chartName="Cumulative Staking Value"
                    days="30 Days"
                    isCheck
                    dataKey="totalValueUsd"
                    data={traderColdWalletOverViewData}
                  /> */}
                  <AreaChartNew
                    chartId="WalletOverview"
                    days="30 Days"
                    chartData={walletOverViewData}
                  />
                </div>
                <div className="flex flex-col h-full justify-center items-end p-2 w-[25%]">
                  <div className="flex flex-col items-center">
                    <span className={`${styles.valueText} text-[#33B1FF]`}>
                      {/* {renderNumber(traderColdWalletOverView?.totalValueUsd ?? 64380.07, true)} */}
                      {renderNumber(walletOverView?.totalValueUsd, true)}
                    </span>
                    <span className={`${styles.Text}`}>Value of Wallet</span>
                  </div>
                </div>
              </div>
            )}

          </div>
          <div className={`bg-white dark:bg-[#26282C] font-semibold rounded-md pb-5 ${colorScheme === 'dark' && styles.dark}`}>
            <div className="!p-0 mb-0 rounded-lg">
              {checkboxes.filter && (
                <FilterExpansionComponent
                  data={filteredWalletData}
                  setData={setFilteredWalletData}
                  currentTab="walletTab"
                  originalData={walletData}
                  setIsFilterActive={setIsFilterActive}
                />
              )}
            </div>
            <div className="pt-5 px-2.5">
              <div className={`grid items-start transition-transform cursor-pointer h-10 px-5 ${styles.WalletHeadingGrid}`}>
                <div className="text-sm font-bold flex gap-3">
                  <span
                    onClick={() => requestSort('token')}
                    className={getClassNamesFor('token')}
                  >
                    Asset
                  </span>
                </div>
                <div className="text-sm font-bold flex gap-3">
                  <span
                    onClick={() => requestSort('quantity')}
                    className={getClassNamesFor('quantity')}
                  >
                    Quantity
                  </span>
                </div>
                <div className="text-sm font-bold flex gap-3">
                  <span
                    onClick={() => requestSort('currentPriceUsd')}
                    className={getClassNamesFor('currentPriceUsd')}
                  >
                    Current Price
                  </span>
                </div>
                <div className="text-sm font-bold flex gap-3">
                  <span
                    onClick={() => requestSort('totalValueUsd')}
                    className={getClassNamesFor('totalValueUsd')}
                  >
                    Total Value
                  </span>
                </div>
                <div className="text-sm font-bold flex gap-3">
                  <span
                    onClick={() => requestSort('dollarCostAvg')}
                    className={getClassNamesFor('dollarCostAvg')}
                  >
                    Dollar Cost Avg
                  </span>
                </div>
                <div className="text-sm font-bold flex gap-3">
                  <span
                    onClick={() => requestSort('percentage')}
                    className={getClassNamesFor('percentage')}
                  >
                    Percentage
                  </span>
                </div>
                <div className="text-sm font-bold flex gap-3">
                  <span
                    onClick={() => requestSort('type')}
                    className={getClassNamesFor('type')}
                  >
                    Type
                  </span>
                </div>
                <div className="text-sm font-bold flex gap-3">
                  <span
                    onClick={() => requestSort('location')}
                    className={getClassNamesFor('location')}
                  >
                    Location
                  </span>
                </div>

              </div>
              <div className={`grid text-xs font-normal text-[#898989] ml-[1.8%] pb-2 py-1.5 ${styles.WalletSubHeadingGrid}`}>
                <div className="flex gap-2.5 font-bold mt-0">
                  <Checkbox
                    styles={{
                      label: {
                        paddingLeft: 4,
                      },
                    }}
                    label="Filter"
                    name="filter"
                    checked={checkboxes.filter}
                    onChange={handleChange}
                    size="xs"
                    disabled={walletData?.length === 0}
                  />
                  {/* <Checkbox
                    styles={{
                      label: {
                        paddingLeft: 4,
                      },
                    }}
                    label="Remove Dust"
                    name="removeDust"
                    checked={checkboxes.removeDust}
                    onChange={handleChange}
                    size="xs"
                    disabled={coldWalletData?.length === 0}
                  /> */}
                </div>
                <div>
                  USD
                </div>
                <div>
                  USD
                </div>
              </div>
              <div className={`custom-scrollbar-css flex flex-col gap-3 ${checkboxes.filter ? 'max-h-[calc(100vh-450px)] 2xl:max-h-[calc(100vh-460px)]' : 'max-h-[calc(100vh-392px)] 2xl:max-h-[calc(100vh-422px)]'} overflow-y-auto pr-2`}>
                <div className="mt-3 bg-white dark:bg-[#26282C]">
                  {dataLoading === loadingStates.LOADING && <WalletTabLoading pageName="Trader" />}
                  {dataLoading === loadingStates.FINISHED && !!items.length && items.map((value) => (
                    <div className={`darkClass ${styles.rowContainer} ${styles.shortRow}`}>
                      <div className={`grid items-center transition-transform px-5 py-3.5 textColor ${styles.WalletRowGrid}`}>
                        <div className="flex items-center gap-3 text-base font-normal">
                          {value?.icon
                            ? (
                              <img
                                className="w-11 h-11 rounded-full"
                                src={value?.icon || `${assetPrefix}/images/CrptoIcon.svg`}
                                alt="Crypto"
                              />
                            )
                            : <ReportMoney className="w-11 h-11" />}

                          <div className="flex flex-col gap-1">
                            <Tooltip label={value?.asset.toUpperCase()} color="black" withArrow>
                              <span
                                className={`${styles.title} text-base`}
                              >
                                {value?.asset?.length > 8 ? `${value?.asset?.slice(0, 8)}...` : value?.asset.toUpperCase() || '-'}
                              </span>
                            </Tooltip>
                          </div>
                        </div>
                        <div className="text-base font-normal flex items-start">
                          <Tooltip label={value?.quantity} disabled={value.quantity === 0} color="black" withArrow>
                            <span>
                              {renderNumber(value?.quantity)}
                            </span>
                          </Tooltip>
                        </div>
                        <div className={`${getClassName(value?.currentPriceUsd, value?.dollarCostAvg)} font-normal text-base`}>
                          <Tooltip label={value?.currentPriceUsd} color="black" withArrow>
                            <span>
                              {renderNumber(value?.currentPriceUsd, true)}
                            </span>
                          </Tooltip>
                        </div>
                        <div className="text-base font-normal">
                          <Tooltip label={value?.totalValueUsd} disabled={value.totalValueUsd === 0} color="black" withArrow>
                            <span>
                              {renderNumber(value?.totalValueUsd, true)}
                            </span>
                          </Tooltip>
                        </div>
                        <div className="text-base font-normal">
                          <Tooltip label={value?.dollarCostAvg} color="black" disabled={value.dollarCostAvg === 0} withArrow>
                            <span>
                              {renderNumber(value?.dollarCostAvg, true)}
                            </span>
                          </Tooltip>
                        </div>
                        <div className={`flex text-base gap-2 ${value?.percentage > 0 ? 'text-green-500' : 'text-red-500'} font-normal`}>
                          {(value?.dollarCostAvg && value?.currentPriceUsd) ? (
                            <>
                              {value?.percentage ? `${(value?.percentage).toFixed(2)}%` : '-'}
                              <img
                                className="w-2 h-2 mt-2"
                                src={value?.percentage > 0 ? `${assetPrefix}/images/GreenArrow.svg` : `${assetPrefix}/images/RedArrow.svg`}
                                alt="ArrowIcon"
                              />
                            </>
                          ) : '-'}
                        </div>
                        <div className="text-base font-normal">
                          {value.type ? value?.type : ''}
                        </div>
                        <div className="text-base font-normal">
                          {value.location ? value?.location : ''}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </div>
  );
};

export default Wallet;
